// import { MsAdalAngular6Service } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { AppStateProvider } from './../services/app-state.provider';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { SecureStorageService } from '../services/secure-storage.service';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  capitalLogin: boolean = true;
  showBridgePlus: boolean = false;
  showCapitalLand: boolean = false;
  bridgePlusLogin: boolean = false;  //change
  loginType: string = '';
  showDeactivated: boolean;
  showForgotPassword;
  showSetPassword: boolean;
  showLogin: boolean = true;
  showEmailSent: boolean;
  enableForgotPwdLink: boolean = true;
  tokens: any;
  isLoaded: boolean = false;
  emailId: string;

  constructor(
    private route: Router,
    private commonService: CommonService,
    private appStateSrv: AppStateProvider,
    private secureStorage: SecureStorageService,
    // private adalService: MsAdalAngular6Service
  ) {
    let redirectType = this.secureStorage.getItem('redirectType');
    let adalAccessToken = this.secureStorage.getItem('adalAccessToken');
    if (adalAccessToken != null || adalAccessToken != '') {
      window.location.href = environment.domain + '/' + redirectType;
    }
    this.secureStorage.removeItem('token');
    this.appStateSrv.setLoginStatus(false);
  }

  ngOnInit(): void {
  }

  submitLogin() {

    this.secureStorage.setItem('loginemailaddress', btoa(this.emailId));

    if (this.emailId !== undefined && this.emailId?.length !== 0) {
      this.getAdmin();
    }
    else {
      this.appStateSrv.showToast(
        "Email can't be Empty"
      );
      this.route.navigateByUrl("");
    }
  }

  submit() {
    // if (this.loginType == '') return;
    // if (this.loginType == 'bridgePlus') this.bridgePlusLogin = true;
    // if (this.loginType == 'capitalLand') this.capitalLogin = true;
    // this.appStateSrv.setIsInitialScreen(!this.bridgePlusLogin);

    let selectedTypeToken;
    let riderctType;
    if (this.loginType == 'bridgePlus') {
      riderctType = 'overview';
      selectedTypeToken = this.tokens.filter(res => {
        if (res.userType === 'Bridge+') {
          return res;
        }
      });
    } else if (this.loginType == 'capitalLand') {
      riderctType = 'parkite-overview';
      selectedTypeToken = this.tokens.filter(res => {
        if (res.userType === 'Parkite') {
          return res;
        }
      });
    }
    this.appStateSrv.setLoginStatus(true);
    this.commonService.setTokenAfterSelection(selectedTypeToken[0]);
    // this.getParkbyClaId(); //closed for token
    this.route.navigateByUrl(riderctType);
  }

  backtoLogin() {
    this.showDeactivated = false;
    this.showForgotPassword = false;
    this.showSetPassword = false;
    this.showLogin = true;
    this.showEmailSent = false;
    this.enableForgotPwdLink = true;
    // localStorage.clear();
  }

  getAdmin() {
    this.commonService.getAdminToken(this.emailId).subscribe(r => {
      if (r.isValid == false) {
        // alert(r.errorMsg);
        this.route.navigateByUrl("");
      }
      else {
        // this.appStateSrv.setLoginStatus(true);
        this.tokens = JSON.parse(this.secureStorage.getItem('Tokens') ?? 'null');
        if (this.tokens.length > 1) {
          this.capitalLogin = false;
        } else {
          let redirectType;
          this.commonService.setTokenAfterSelection(this.tokens[0]);
          if (this.tokens[0].userType == 'Bridge+') {
            redirectType = "overview";
          } else if (this.tokens[0].userType == 'Parkite') {
            redirectType = "parkite-overview" //Change once the ui is done
          }
          this.appStateSrv.setLoginStatus(true);
          // this.route.navigateByUrl(redirectType);
          // this.adalService.login();
          //redirect to particular home
        }
        // this.route.navigateByUrl("overview");
      }
    });
  }

  select(type) {
    if (type == 'bridgePlus') {
      this.showBridgePlus = true;
      this.showCapitalLand = false;
    }
    if (type == 'capitalLand') {
      this.showBridgePlus = false;
      this.showCapitalLand = true;
    }
    this.loginType = type;
  }

  getParkbyClaId() {
    this.commonService.getParkByCLAId().subscribe(res => {
      if (res.isValid) {
        localStorage.setItem('parkId', res.list[0].parkId)
        localStorage.setItem('parkDropDownDetails', JSON.stringify(res.list))
      }
    });
  }
}
